import API from '@/services/api'

export const FETCH_ONLINE_DOSSIER = 'fetchOnlineDossier'

// Mutations
export const STORE_SET_ONLINE_DOSSIER = 'storeSetOnlineDossier'

const state = {
	onlineDossier: {
		id: null,
		street: null,
		housenumber: null,
		housenumber_addition: null,
		city: null,
		zipcode: null,
		country: null,
		type: null,
		duration: null,
		description: null,
		inspection_type: null,
		project: {
			id: null,
			name: null,
			description: null,
			file_id: null,
			startDate: null,
			status: 0,
			created_at: null,
			updated_at: null,
			activities: [],
			images: [],
			author: {
				name: null,
			},
			company: {
				name: null,
			},
		},
		schedule: [],
		inspections: [],
	},
}

const getters = {
	onlineDossier (state) {
		return state.onlineDossier
	},
}

const actions = {
	[FETCH_ONLINE_DOSSIER] (context, token) {
		return new Promise((resolve, reject) => {
			API.query('online-dossier/' + token).then((response) => {
				context.commit(STORE_SET_ONLINE_DOSSIER, response.data)
				resolve(response.data)
			}).catch((response) => {
				reject(response)
			})
		})
	},
}

const mutations = {
	[STORE_SET_ONLINE_DOSSIER] (state, dossier) {
		state.onlineDossier = dossier
	},
}

export default {
	state,
	actions,
	mutations,
	getters,
}